export default "__VITE_ASSET__BRgmmz7N__"